import {
  RENT_LLD_DOWNLOADED,
  RENT_LLD_SENDING,
  RENTS_LLD_DOWNLOADED,
  RENTS_LLD_FAILED,
  RENTS_LLD_PENDING,
  RENTS_LLD_RESET,
  RENT_BOOK_LLD_DOWNLOADED
} from './types';

const INITIAL_STATE = {
  pending: false,
  sending: false,
  error: null,
  content: null,
};

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case RENTS_LLD_PENDING:
      return {
        ...state,
        pending: true,
      };
    case RENT_LLD_SENDING: {
      return {
        ...state,
        sending: true,
      };
    }
    case RENTS_LLD_FAILED:
      return {
        ...state,
        pending: false,
        sending: false,
        error: action.payload,
      };
    case RENTS_LLD_DOWNLOADED:
      return {
        ...state,
        pending: false,
        sending: false,
        content: action.payload,
      };
    case RENT_LLD_DOWNLOADED: {
      const rent = action.payload;
      let newState = { ...state };
      const rentIndex = newState.content.rents.findIndex(elem => elem.id = rent.id);
      if (rentIndex > -1) {
        newState.content.rents.splice(rentIndex, 1, rent);
      } else {
        newState.content.rents.push(rent);
        newState.content.nb_rents = state.content.nb_rents + 1;
      }
      return {
        ...newState,
        sending: false,
        pending: false,
      };
    }
    case RENT_BOOK_LLD_DOWNLOADED: {
      const rent = action.payload.rent;
      const book = action.payload.book;
      let newState = { ...state };
      const rentIndex = newState.content.rents.findIndex(elem => elem.id = rent.id);
      if (rentIndex > -1) {
        newState.content.rents[rentIndex].book = book;
      }
      return {
        ...newState,
        sending: false,
        pending: false,
      };
    }
    case RENTS_LLD_RESET:
      return INITIAL_STATE;
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/store/rentsLld/reducers.js